import type { WorkoutExerciseGroup } from "@/data/dummyData";

export type WorkoutSessionStep = {
  id: string;
  exerciseId: string;
  exerciseIndex: number;
  groupId: string;
  groupIndex: number;
  roundIndex: number;
  roundCount: number;
  exerciseIndexInGroup: number;
  displayStartSet: number;
  displaySetCount: number;
  isGrouped: boolean;
};

export function buildSessionSteps(
  exerciseGroups: WorkoutExerciseGroup[],
  exerciseIndexById: Map<string, number>
): WorkoutSessionStep[] {
  return exerciseGroups.flatMap((group, groupIndex) => {
    if (group.label === "Single") {
      const exercise = group.exercises[0];
      if (!exercise) return [];
      return [{
        id: `${group.id}:${exercise.id}:single`,
        exerciseId: exercise.id,
        exerciseIndex: exerciseIndexById.get(exercise.id) ?? 0,
        groupId: group.id,
        groupIndex,
        roundIndex: 0,
        roundCount: 1,
        exerciseIndexInGroup: 0,
        displayStartSet: 1,
        displaySetCount: exercise.sets,
        isGrouped: false,
      }];
    }

    const rounds = Math.max(group.rounds || 0, 1);
    return Array.from({ length: rounds }, (_, roundIndex) =>
      group.exercises.map((exercise, exerciseIndexInGroup) => {
        const setsPerRound = Math.max(exercise.grouping?.setsPerRound ?? 1, 1);
        return {
          id: `${group.id}:${exercise.id}:round:${roundIndex + 1}`,
          exerciseId: exercise.id,
          exerciseIndex: exerciseIndexById.get(exercise.id) ?? 0,
          groupId: group.id,
          groupIndex,
          roundIndex,
          roundCount: rounds,
          exerciseIndexInGroup,
          displayStartSet: roundIndex * setsPerRound + 1,
          displaySetCount: setsPerRound,
          isGrouped: true,
        };
      })
    ).flat();
  });
}
